<template>
  <v-app class="whole">
    <div class="inside">
      <v-img src="./watch.jpg" :height="300" ></v-img>
      <div class="btnSpace_back display_desktop">
        <v-btn color="primary" x-large text @click="goback"><span class="material-icons">
          chevron_left</span>もどる</v-btn>
      </div>
    <div class="myform">
      <div class="title-spaced">
      </div>

      <div class="titleCompany">注意事項</div>
      <div class="memoText">
          <p>①オーダーメイド商品はお客様のご要望に沿えることを100%保証するものではございません。</p>

          <p>②極端なシルエットはラインが大幅に崩れてしまう恐れや構造上不可能な場合がございます。その際は全体のバランスを考慮して、当店判断のもと微調整をさせて頂く場合がございますので予めご了承下さい。</p>

          <p>③仕様書、上記記載以外に関しましては全て当社規定のデザインとなります。商品完成後のデザイン・仕様の変更は有償とさせて頂いております。また構造上ご要望に添えずお断りさせて頂く場合がございます。</p>

          <p>④商品完成後のサイズ修正は、各アイテム2週間以内に限り1回まで無償で対応致します。お引渡し後、2週間以内に当店までお持ち頂くか、郵送でお送り下さい。電話・メールでお問合せ頂いた場合でも、商品が当店に到着するのが2週間を過ぎている場合は対象外となり、有償での対応となりますのでご注意ください。配送費はお客様負担となります。</p>

          <p>⑤引き渡しの際はサイズ確認も含め担当スタイリストが最後まで責任を持って対応させて頂きます。「担当スタイリスト以外での受け取りを希望される場合」・「ご試着なしで受け取りを希望される場合」のサイズ修正に関しては有償またはお断りさせて頂いておりますので予めご了承下さい。当店都合でスタイリストが変更になった場合・遠方のお客様で郵送の場合は④が適用となります。</p>

          <p>⑥サイズ修正がご希望の際は縫い代を使った対応となります。当店では縫い代を多めにとっておりますが、対応できかねますご要望に関してはお断りさせて頂く場合もございます。ミリ単位の修正、個人的主観による修正希望の場合は、1回目から有償、若しくはお断りさせて頂く場合もございますので予めご了承ください。また採寸からお引き渡しまでに大幅な体系の変化があった場合には有償での対応とさせて頂いております。</p>

          <p>⑦全て人の手でお作りしていますので、ミリ単位の誤差は許容範囲とさせて頂きます。</p>

          <p>⑧最終の納品完了(お引渡し)は、当社判断で決定させて頂く場合がございます。</p>

          <p>⑨オーダーメイド商品の性質上、ご注文後のキャンセルはお受け致し兼ねますので予めご了承ください。</p>

          <p>⑩当店はお客様にご満足頂けるよう最大限の努力をし、誠意をもって取り組んでおりますが、悪質なクレームに関しては以後のご入店を固くお断りさせて頂いております。その際は当店の一切のサービスを利用することは出来ません。</p>

          <p>⑪1年以上お引き取りがない商品に関しては、当社判断のもと処分とさせて頂いております。</p>

          <p>⑫ご予約のキャンセルは１日前までにご連絡をお願い致します。当日に無断でキャンセルされた場合、キャンセル料として5,000円いただきますので、予めご了承ください。</p>
      </div>
    </div>
    </div>
  </v-app>
</template>

<script>
import products from "./ECサイト商品リスト.json";
import { mapGetters } from "vuex"
  export default {
    data() {
      return {
        inputForm: {},      
        checkboxdata: [],
        item: '上記の内容と同じ',
        val: true,
        items: [],
        products,
      }
    },
    computed:{
      product() {
        const result = products.find((v) => v.id === Number(this.id))
        return result
      },
      ...mapGetters('cart', ['productsList','profile']),
      totalPrice() {
        let totalPrice = 0
        for(let item in this.productsList){
          
          let id = this.productsList[item]
          // window.console.log('id: ', id)
          const result = products.find((v) => v.id === Number(id))
          this.items.push(result)

          totalPrice += result.price
        }

        return totalPrice
      },
    },
    mounted() {
     
    },
    filters: {
      toLocaleString(value) {
        return value.toLocaleString();
      },
    },
    methods: {
      buy() {
        // this.$store.dispatch('cart/updateProfile', inputForm )
        // this.$router.push({ name: 'co-info' })
      },
      goback() {
        this.$router.go(-1)
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 70%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .memoText {
    margin: 2% 5% 5% 5% ;
  }
</style>